import { DialogPositioningBehavior, DialogProps, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { BulkEditDialogBody } from './BulkEditDialogBody';

export const IPALLOWLIST_BULK_EDIT_DIALOG_TEST_ID = 'ipallowlist-bulk-edit-dialog';

export const openBulkEditDialog = (allowedIPs: string[], onSave?: (allowedIPs: string[]) => Promise<void>): void => {
    ReactModalService.openCustom(closeAndDismiss => {
        const dialogProps = ReactModalService.getDefaultDialogProps({
            type: DialogType.NormalWithTitleBar,
            title: Messages.ipAllowlistBulkEditDialogTitle(),
            testId: IPALLOWLIST_BULK_EDIT_DIALOG_TEST_ID,
            showCloseButton: true,
            dialogWidth: TabDialogWidth.width600px,
            dialogHeight: TabDialogWidth.width375px,
            positioningBehavior: DialogPositioningBehavior.Draggable,
            shouldNotCloseOnGlassClick: true,
        }, closeAndDismiss);
        return getDialogWidget(dialogProps, closeAndDismiss, allowedIPs, onSave);
    });
};

const getDialogWidget = (dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, allowedIPs: string[], onSave?: (allowedIPs: string[]) => Promise<void>) => {
    return (
        <DialogWidget {...dialogProps}>
            <BulkEditDialogBody allowedIPs={allowedIPs} closeAndDismiss={closeAndDismiss} onSave={onSave}/>
        </DialogWidget>
    );
};